"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signMessage = void 0;
const serialize_1 = require("../utils/serialize");
const errors_1 = require("../errors");
const internal_1 = require("../types/internal");
const utils_1 = require("../utils");
const getVersion_1 = require("./getVersion");
const messageData_1 = require("./serialization/messageData");
const parse_1 = require("../utils/parse");
const send = (params) => (Object.assign({ ins: 36 }, params));
function* signMessage(version, msgData) {
    if (!(0, getVersion_1.getCompatibility)(version).supportsMessageSigning) {
        throw new errors_1.DeviceVersionUnsupported(`CIP-8 message signing not supported by Ledger app version ${(0, utils_1.getVersionString)(version)}.`);
    }
    yield send({
        p1: 1,
        p2: 0,
        data: (0, messageData_1.serializeMessageDataInit)(version, msgData),
        expectedResponseLength: 0,
    });
    const MAX_CIP8_MSG_FIRST_CHUNK_ASCII_SIZE = 198;
    const MAX_CIP8_MSG_FIRST_CHUNK_HEX_SIZE = 99;
    const MAX_CIP8_MSG_HIDDEN_CHUNK_SIZE = 250;
    const msgBytes = (0, serialize_1.hex_to_buf)(msgData.messageHex);
    const getChunkData = (start, end) => {
        const chunk = msgBytes.slice(start, end);
        return Buffer.concat([(0, serialize_1.uint32_to_buf)(chunk.length), chunk]);
    };
    const firstChunkSize = msgData.isAscii
        ? MAX_CIP8_MSG_FIRST_CHUNK_ASCII_SIZE
        : MAX_CIP8_MSG_FIRST_CHUNK_HEX_SIZE;
    let start = 0;
    let end = Math.min(msgBytes.length, firstChunkSize);
    yield send({
        p1: 2,
        p2: 0,
        data: getChunkData(start, end),
        expectedResponseLength: 0,
    });
    start = end;
    if (start < msgBytes.length) {
        (0, parse_1.validate)(msgData.hashPayload, errors_1.InvalidDataReason.MESSAGE_DATA_LONG_NON_HASHED_MSG);
    }
    while (start < msgBytes.length) {
        end = Math.min(msgBytes.length, start + MAX_CIP8_MSG_HIDDEN_CHUNK_SIZE);
        yield send({
            p1: 2,
            p2: 0,
            data: getChunkData(start, end),
            expectedResponseLength: 0,
        });
        start = end;
    }
    const MAX_ADDRESS_SIZE = 128;
    const confirmResponse = yield send({
        p1: 3,
        p2: 0,
        data: Buffer.concat([]),
        expectedResponseLength: internal_1.ED25519_SIGNATURE_LENGTH + internal_1.PUBLIC_KEY_LENGTH + 4 + MAX_ADDRESS_SIZE,
    });
    let s = 0;
    const signatureHex = confirmResponse
        .slice(s, s + internal_1.ED25519_SIGNATURE_LENGTH)
        .toString('hex');
    s += internal_1.ED25519_SIGNATURE_LENGTH;
    const signingPublicKeyHex = confirmResponse
        .slice(s, s + internal_1.PUBLIC_KEY_LENGTH)
        .toString('hex');
    s += internal_1.PUBLIC_KEY_LENGTH;
    const addressFieldSizeBuf = confirmResponse.slice(s, s + 4);
    s += 4;
    const addressFieldSize = (0, serialize_1.buf_to_uint32)(addressFieldSizeBuf);
    const addressFieldHex = confirmResponse
        .slice(s, s + addressFieldSize)
        .toString('hex');
    return {
        signatureHex,
        signingPublicKeyHex,
        addressFieldHex,
    };
}
exports.signMessage = signMessage;
//# sourceMappingURL=data:application/json;base64,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